export default __webpack_public_path__ + "static/media/icon-space-hatchling.e01387ff.svg";